export enum FeatureFlagNames {
  BREWHOUSE_UNITS_PREFERENCE = 'BrewhouseUnitsPreference',
  CDC_STREAMING_MANAGEMENT = 'CdcStreamingManagement',
  ENABLE_LOGOUT_FOR_HOP_RECIPE_VIEWER = 'EnableLogoutForHopRecipeViewer',
  HOP_POSITION_MAINTENANCE_AUDIT_TABLE = 'HopPositionMaintenanceAuditTable',
  HOPS_LOT_NUMBER_CROP_YEAR_CHANGE = 'HopsLotNumberCropYearChange',
  KPI_CALCULATOR = 'Data Management Portal',
  KPI_TREE = 'KpiTree',
  LOT_NUMBER_SINGLE_BRAND = 'Lot_Number_Single_Brand',
  MULTI_SELECT_VARIETIES_LOT_CHANGE = 'MultiSelectVarietiesLotChange',
  SUPPLY_DATA_MANAGEMENT_PORTAL = 'PolkaDots',
  VIEW_ASSIGN_ACTIVE_LOT_NUMBERS = 'ViewAssignActiveLotNumbers',
  URGENT_SPECIALS = 'UrgentSpecials',
  USE_NEW_AUDIT_LOGS_LOGIC = 'UseNewAuditLogsLogic'
}
